import { useEffect, useMemo, useState, useRef } from "react";
import { getToken } from "../../../services/authService";
import { showSuccessToast } from "../../../components/toast/toastBus";
import styles from "../styles/evento-form.module.css";
import { useNavigate } from "react-router-dom";
import { uploadFile, deleteFileByUrl } from "../../../services/fileService";
import { buildArmasIndex } from "../domain/armasIndex";
import { useFormActions } from "../hooks/useFormActions";
import { Stepper } from "../components/Stepper";
import { StepDatos } from "../components/steps/StepDatos";
import { StepParticipantes } from "../components/steps/StepParticipantes";
import { StepCacerias } from "../components/steps/StepCacerias";
import { StepMenus } from "../components/steps/StepMenus";
import { StepActividades } from "../components/steps/StepActividades";
import { StepResumen } from "../components/steps/StepResumen";
import { StepTransfer } from "../components/steps/StepTransfer";
import { isEmptyParticipacion, toSpanishDate } from "../domain/eventoUtils";
import { buildEventoPayload } from "../domain/eventoPayload";
import { createEvento, updateEvento } from "../api/eventosApi";
import { defaultEventoForm, mapEventoToForm } from "../domain/eventoFormMapper";
import { useAccordionState } from "../hooks/useAccordionState";
import { useEventosCatalogos } from "../hooks/useEventosCatalogos";
import { useEventosOptions } from "../hooks/useEventosOptions";
import { useCaceriasFiles } from "../hooks/useCaceriasFiles";


export default function AñadirEvento({ onEventoCreado, onEventoActualizado, evento }) {
  const navigate = useNavigate();
  const [step, setStep] = useState(0);
  const steps = ["Datos", "Participantes", "Transfer", "Cacerías", "Menús & Vinos", "Actividades", "Resumen"];
  const apiUrl = process.env.REACT_APP_API_URL;
  const [notice, setNotice] = useState("");
  const [busquedaPersona, setBusquedaPersona] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const {
    loading: catalogosLoading,
    error: catalogosError,

    personas,
    platos,
    vinos,
    habitaciones,
    roles,
    armas,

    tiposCaceria,
    tiposEvento,

    personasById,
    rolesById,
    habitacionesById,
    platosById,
  } = useEventosCatalogos(apiUrl);

  const [dragPart, setDragPart] = useState(null);

  const [form, setForm] = useState(() => (evento ? mapEventoToForm(evento) : defaultEventoForm));

  const [filesEvento, setFilesEvento] = useState({
    fileEventoDocumento: null,
  });

  useEffect(() => {
    const base = evento ? mapEventoToForm(evento) : defaultEventoForm;

    const participaciones = renumberParticipaciones(base.participaciones || []);

    setForm({ ...base, participaciones });
    setFilesEvento({ fileEventoDocumento: null });
  }, [evento]);

  const renumberParticipaciones = (arr) =>
    (arr || []).map((p, idx) => ({ ...p, orden: idx }));


  const POS_LABELS = ["Primer plato", "Segundo plato", "Postre"];


  const { filesCaceria, handleCaceriaFileChange, clearRutaDoc, deleteRutaDocServer } = useCaceriasFiles({
    cacerias: form.cacerias,
    setForm,
    deleteFileByUrl,
  });

  const {
    setOpenCacerias,
    setOpenParts,
    setOpenActs,
    setOpenMenus,

    toggleCaceria,
    togglePart,
    toggleAct,
    toggleMenu,
    toggleSub,

    isCaceriaOpen,
    isPartOpen,
    isActOpen,
    isMenuOpen,
    isSubOpen,
  } = useAccordionState();



  const getRolNameById = (rolId) => {
    const r = rolesById.get(String(rolId));
    return r?.rol;
  };


  const dedupById = (arr) => {
    const seen = new Set();
    return arr.filter((p) => (p?.id != null) && !seen.has(p.id) && seen.add(p.id));
  };

  const personasDisponiblesEnCaceria = (rolId, currentPersonaId) => {
    const rolName = getRolNameById(rolId);

    if (rolName === "CAZADOR") {
      let lista = personasParticipantesEvento;

      if (currentPersonaId && !idsParticipantesEvento.has(Number(currentPersonaId))) {
        const curr = personasById.get(String(currentPersonaId));
        if (curr) lista = [curr, ...lista];
      }
      return dedupById(lista);
    }

    if (rolName === "SECRETARIO" || rolName === "CARGADOR") {
      let lista = personasStaff;

      if (currentPersonaId && !lista.some((p) => Number(p.id) === Number(currentPersonaId))) {
        const curr = personasById.get(String(currentPersonaId));
        if (curr) lista = [curr, ...lista];
      }
      return dedupById(lista);
    }

    return dedupById(personas);
  };

  const agentesOptions = useMemo(() => {
    return (personas || [])
      .filter(p => p?.tipoPersona === "AGENTE")
      .map(p => ({ value: p.id, label: `${p.nombre} ${p.apellidos}` }));
  }, [personas]);

  const { setField, updateArray, addItem, removeItem, moveItem } = useFormActions(setForm);


  const personasEvento = useMemo(() => {
    return (form.participaciones || [])
      .map((pp) => pp.personaId)
      .filter((id) => id !== "" && id != null)
      .map((id) => personasById.get(String(id)))
      .filter(Boolean);
  }, [form.participaciones, personasById]);

  const idsParticipantesEvento = useMemo(() => {
    return new Set(
      (form.participaciones || [])
        .map((pp) => pp.personaId)
        .filter((id) => id != null && id !== "")
        .map((id) => Number(id))
    );
  }, [form.participaciones]);


  const personasStaff = useMemo(() => {
    return (personas || []).filter((p) => p?.tipoPersona === "STAFF");
  }, [personas]);

  const personasParticipantesEvento = useMemo(() => {
    return (personas || []).filter((p) => idsParticipantesEvento.has(Number(p.id)));
  }, [personas, idsParticipantesEvento]);


  const armasIndex = useMemo(() => buildArmasIndex(armas), [armas]);

  const personasEventoOptions = useMemo(
    () =>
      personasEvento.map((p) => ({ value: p.id, label: `${p.nombre} ${p.apellidos}` })),
    [personasEvento]
  );



  useEffect(() => {
    setForm((prev) => {
      const totalMenus = (prev.menus || []).length;
      const allMenuIdxs = Array.from({ length: totalMenus }, (_, i) => i);
      const participaciones = (prev.participaciones || []).map((p) => ({
        ...p,
        menuIds: allMenuIdxs,
      }));
      return { ...prev, participaciones };
    });
  }, [form.menus.length]);

  const validateStep = (currentStep) => {
    if (currentStep === 0) {
      const { nombre, fechaInicio, fechaFin } = form;
      if (!nombre?.trim()) {
        setNotice("El evento debe tener un nombre.");
        return false;
      }
      if (fechaFin < fechaInicio) {
        setNotice("La fecha de fin no puede ser anterior a la fecha de inicio.");
        return false;
      }
    }
    setNotice("");
    return true;
  };

  const handleNext = () => {
    if (!validateStep(step)) return;
    setStep((s) => Math.min(s + 1, steps.length - 1));
  };

  const handlePrev = () => {
    setNotice("");
    setStep((s) => Math.max(s - 1, 0));
  };

  const LAST_STEP = steps.length - 1;
  const isLastStep = step === LAST_STEP;


  /** ---------- SUBMIT ---------- */
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateStep(0)) {
      setStep(0);
      return;
    }

    try {
      const token = getToken();

      // 1) Subida de ficheros
      let uploadsCacerias = [];
      try {
        uploadsCacerias = await Promise.all(
          (form.cacerias || []).map((c, idx) =>
            filesCaceria[idx] ? uploadFile(filesCaceria[idx], "eventos/cacerias") : null
          )
        );
      } catch (e) {
        console.error(e);
        setNotice("Error subiendo documentos de cacerías: " + (e?.message || "error desconocido"));
        return;
      }

      let uploadEventoDoc = null;
      try {
        const uploaded = filesEvento.fileEventoDocumento
          ? await uploadFile(filesEvento.fileEventoDocumento, "eventos")
          : null;

        // Soporta que uploadFile devuelva string o { url } o { fileUrl } etc.
        uploadEventoDoc =
          typeof uploaded === "string"
            ? uploaded
            : (uploaded?.url || uploaded?.fileUrl || uploaded?.ruta || uploaded?.path || null);
      } catch (e) {
        console.error(e);
        setNotice("Error subiendo el documento del evento.");
        return;
      }

      const formConOrden = {
        ...form,
        participaciones: renumberParticipaciones(form.participaciones || []),
      };

      // 3) Montar payload final
      const formLimpio = buildEventoPayload({
        form: formConOrden,
        uploadsCacerias,
        getRolNameById,
      });

      if (uploadEventoDoc) {
        formLimpio.rutaDocumento = uploadEventoDoc;
      }

      // Normalización: si viene vacío, manda null (opcional pero recomendable)
      if (formLimpio.rutaDocumento != null && String(formLimpio.rutaDocumento).trim() === "") {
        formLimpio.rutaDocumento = null;
      }

      const apiUrl = process.env.REACT_APP_API_URL;



      setNotice("");
      setFilesEvento((p) => ({ ...p, fileEventoDocumento: null }));

      const LAST_STEP = steps.length - 1;
      const isLastStep = step === LAST_STEP;

      let data;
      if (evento) {
        data = await updateEvento({ apiUrl, token, id: evento.id, payload: formLimpio });
        onEventoActualizado?.(data, { close: isLastStep });
      } else {
        data = await createEvento({ apiUrl, token, payload: formLimpio });
        onEventoCreado?.(data, { close: isLastStep });
      }

      if (!isLastStep) {
        return;
      }

      showSuccessToast(evento ? "Evento actualizado con éxito" : "Evento creado con éxito");
      navigate(`/eventos/${data.id}`);


    } catch (err) {
      console.error(err);
      setNotice("Error de red guardando el evento.");
    }
  };

  const { platoOptions, vinoOptions, habitacionOptions } = useEventosOptions({
    platos,
    vinos,
    habitaciones,
  });


  useEffect(() => {
    const onKey = (e) => {
      if (e.altKey && e.key.toLowerCase() === "n") {
        if (step === 4) addItem("menus", { nombre: "", fecha: "", lugar: "", comensales: 0, platoIds: [], vinoIds: [] });
        if (step === 5) addItem("actividades", { nombre: "", tipo: "", fecha: "", participanteIds: [] });
        if (step === 1) addItem("participaciones", { personaId: "", habitacionIds: [], actividadIds: [], menuIds: [] });
        if (step === 3) addItem("cacerias", { fecha: "", rutaDocumento: "", tipoCaceria: "", participaciones: [] });
      }
      if (e.altKey && e.key.toLowerCase() === "s") {
        e.preventDefault();
        handleNext();
      }
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [step, addItem, handleNext]);




  const cloneCaceria = (caceria) => ({
    ...caceria,
    participaciones: (caceria.participaciones || []).map((p) => ({
      ...p,
    })),
  });

  const duplicateCaceria = (idx) => {
    setForm((prev) => {
      const original = prev.cacerias[idx];
      if (!original) return prev;

      const copia = cloneCaceria(original);

      const nuevas = [
        ...prev.cacerias.slice(0, idx + 1),
        copia,
        ...prev.cacerias.slice(idx + 1),
      ];

      return {
        ...prev,
        cacerias: nuevas,
      };
    });

    setOpenCacerias((prev) => {
      const s = new Set(prev);
      s.add(idx + 1);
      return s;
    });
  };

  const totalParticipantesEvento = useMemo(
    () =>
      (form.participaciones || []).filter((p) => !isEmptyParticipacion(p)).length,
    [form.participaciones]
  );

  const prevTotalParticipantesRef = useRef(totalParticipantesEvento);

  useEffect(() => {
    const prevTotal = prevTotalParticipantesRef.current;
    const currentTotal = totalParticipantesEvento;

    if (prevTotal === currentTotal) return;

    setForm((prevForm) => {
      const updatedMenus = (prevForm.menus || []).map((m) => {
        const c = m.comensales;

        if (c == null || c === "" || c === prevTotal) {
          return { ...m, comensales: currentTotal };
        }
        return m;
      });

      return { ...prevForm, menus: updatedMenus };
    });
    prevTotalParticipantesRef.current = currentTotal;
  }, [totalParticipantesEvento, setForm]);

  const participacionesView = useMemo(() => {
    const b = busqueda.toLowerCase();
    return (form.participaciones || [])
      .map((p, idx) => ({ p, idx }))
      .filter(({ p }) => {
        const persona = personasById.get(String(p.personaId));
        if (!persona) return true;
        return (
          persona.nombre.toLowerCase().includes(b) ||
          persona.apellidos.toLowerCase().includes(b)
        );
      });
  }, [form.participaciones, personasById, busqueda]);

  const moveParticipacion = (fromIdx, toIdx) => {
    if (fromIdx === toIdx || fromIdx == null || toIdx == null) return;

    setForm((prev) => {
      const arr = [...(prev.participaciones || [])];
      if (fromIdx < 0 || fromIdx >= arr.length || toIdx < 0 || toIdx >= arr.length) return prev;

      const [moved] = arr.splice(fromIdx, 1);
      arr.splice(toIdx, 0, moved);

      return {
        ...prev,
        participaciones: renumberParticipaciones(arr),
      };
    });

    // Mantener el input de búsqueda alineado con el orden visual
    setBusquedaPersona((prev) => {
      const arr = Array.isArray(prev) ? [...prev] : [];
      if (fromIdx < 0 || fromIdx >= arr.length || toIdx < 0 || toIdx >= arr.length) return prev;
      const [moved] = arr.splice(fromIdx, 1);
      arr.splice(toIdx, 0, moved);
      return arr;
    });
  };


  return (
    <div className={styles.page}>
      <form className={`${styles.wrap} ${styles.stack}`} onSubmit={handleSubmit}>


        <div className={styles["alert-layer"]} aria-live="polite">
          {notice && <div className={`${styles.alert} ${styles.error}`}>{notice}</div>}
        </div>

        <div className={styles.content}>
          <Stepper steps={steps} step={step} onStepChange={setStep} />

          {step === 0 && (
            <StepDatos
              form={form}
              setField={setField}
              setForm={setForm}
              personas={personas}
              files={filesEvento}
              setFiles={setFilesEvento}
            />
          )}

          {step === 1 && (
            <StepParticipantes
              form={form}
              personas={personas}
              participacionesView={participacionesView}
              busquedaPersona={busquedaPersona}
              setBusquedaPersona={setBusquedaPersona}
              dragPart={dragPart}
              setDragPart={setDragPart}
              personasById={personasById}
              habitacionesById={habitacionesById}
              habitacionOptions={habitacionOptions}
              isPartOpen={isPartOpen}
              togglePart={togglePart}
              isSubOpen={isSubOpen}
              toggleSub={toggleSub}
              setOpenParts={setOpenParts}
              addItem={addItem}
              removeItem={removeItem}
              updateArray={updateArray}
              moveParticipacion={moveParticipacion}
              agentesOptions={agentesOptions}
            />
          )}

          {step === 2 && (
            <StepTransfer
              form={form}
              setField={setField}
            />
          )}


          {step === 3 && (
            <StepCacerias
              form={form}
              notice={notice}
              setNotice={setNotice}
              roles={roles}
              tiposCaceria={tiposCaceria}
              personas={personas}
              getRolNameById={getRolNameById}
              personasDisponiblesEnCaceria={personasDisponiblesEnCaceria}
              armasIndex={armasIndex}
              isCaceriaOpen={isCaceriaOpen}
              toggleCaceria={toggleCaceria}
              setOpenCacerias={setOpenCacerias}
              addItem={addItem}
              removeItem={removeItem}
              updateArray={updateArray}
              setForm={setForm}
              filesCaceria={filesCaceria}
              handleCaceriaFileChange={handleCaceriaFileChange}
              clearRutaDoc={clearRutaDoc}
              deleteRutaDocServer={deleteRutaDocServer}
              duplicateCaceria={duplicateCaceria}
            />
          )}

          {step === 4 && (
            <StepMenus
              form={form}
              setForm={setForm}
              setNotice={setNotice}
              addItem={addItem}
              removeItem={removeItem}
              updateArray={updateArray}
              isMenuOpen={isMenuOpen}
              toggleMenu={toggleMenu}
              setOpenMenus={setOpenMenus}
              platosById={platosById}
              platoOptions={platoOptions}
              vinoOptions={vinoOptions}
              totalParticipantesEvento={totalParticipantesEvento}
              POS_LABELS={POS_LABELS}
            />
          )}


          {step === 5 && (
            <StepActividades
              form={form}
              setNotice={setNotice}
              addItem={addItem}
              removeItem={removeItem}
              updateArray={updateArray}
              isActOpen={isActOpen}
              toggleAct={toggleAct}
              setOpenActs={setOpenActs}
              tiposEvento={tiposEvento}
              personasEventoOptions={personasEventoOptions}
            />
          )}


          {step === 6 && (
            <StepResumen
              form={form}
              toSpanishDate={toSpanishDate}
            />
          )}
        </div>

        <div className={styles.toolbar}>
          <div className={styles.bar}>
            <div className={styles["toolbar-left"]}>
              <button
                type="submit"
                className={`${styles.btn} ${styles.primary}`}
                title="Guardar cambios del evento"
              >
                {evento ? "Actualizar evento" : "Guardar evento"}
              </button>

              {/* Atrás (si procede) */}

            </div>

            <div className={styles["toolbar-right"]}>
              {step > 0 && (
                <button
                  type="button"
                  className={`${styles.btn} ${styles.ghost}`}
                  onClick={handlePrev}
                >
                  Atrás
                </button>
              )}
              {step < steps.length - 1 && (
                <button
                  type="button"
                  className={`${styles.btn} ${styles.primary}`}
                  onClick={handleNext}
                >
                  Siguiente
                </button>
              )}
            </div>
          </div>
        </div>

      </form>
    </div>
  );
}
